import React from 'react';

import classNames from 'classnames';

import './NavigationMenuScrollWrapper.scss';

interface NavigationMenuScrollWrapperProps extends React.PropsWithChildren {
  disableScroll?: boolean;
}

export const NavigationMenuScrollWrapper: React.FC<NavigationMenuScrollWrapperProps> = ({
  children,
  disableScroll = false,
}) => (
  <div
    className={classNames('uno-overflow-y-auto uno-flex uno-flex-col uno-flex-grow-1 uno-flex-basis-50', {
      'uno-overflow-y-visible': disableScroll,
    })}
  >
    {children}
  </div>
);
